export const restOfDivision = (dividend, divider) => {
  return dividend % divider
}

export default restOfDivision
